import { Editor } from '@tinymce/tinymce-react';
import React, { useContext } from 'react'
import { Button, ButtonGroup, Col, Container, Row } from 'react-bootstrap';
import { trackPromise } from 'react-promise-tracker';
import Swal from 'sweetalert2';
import DommusBarraTitulo from '../../../components/DommusBarraTitulo';
import ItemBarraTitulo from '../../../components/DommusBarraTitulo/ItemBarraTitulo';
import DommusToggle from '../../../components/DommusToggle';
import { AtendimentoContext } from '../../../contexts/AtendimentoContext';
import caAPI from '../../../services/caAPI';
import { PerfilUsuarioService } from '../../../services/PerfilUsuarioService';
import "./index.css";
import EditorDommusTags from '../../../components/EditorDommusTags';

export default function GerenciarAssinatura() {
    const { assinaturaUsuario, setAssinaturaUsuario } = useContext(AtendimentoContext);

    const handleEditorChange = (content, editor) => {
        setAssinaturaUsuario(content);
    }

    const salvarAssinatura = () => {
        let dados = { assinatura: assinaturaUsuario }

        trackPromise(PerfilUsuarioService.update(caAPI.getLocalState('idUsuario'), dados))
            .then(() => {
                Swal.fire({
                    titleText: "Sucesso!",
                    text: `Assinatura salva com sucesso!`,
                    icon: 'success'
                })
            })
            .catch(error => Swal.fire({
                titleText: "Ooops...",
                text: `Houve um problema ao salvar a sua assinatura. ${error}`,
                icon: 'error'
            }))
    }

    return (
        <Container fluid>

        <div>
            <DommusBarraTitulo>
                <ItemBarraTitulo>
                    Gerenciar Assinatura
                </ItemBarraTitulo>
            </DommusBarraTitulo>

            <DommusToggle title='Assinatura' toggle={true} className="assinatura">
                <Row>
                    <Col>
                        <Row>
                            <Col>
                                <div className='editor-assinatura'>
                                  <EditorDommusTags
                                    handleEditorChange={handleEditorChange}
                                    conteudo={assinaturaUsuario}
                                    gruposTags={[]}
                                    utilizarDommusTag={false}
                                  />
                                </div>
                            </Col>
                        </Row>
                                        <br></br>
                            <Row>
                                <Col className="d-flex justify-content-end">
                                    <ButtonGroup  size="lg">
                                        <Button
                                            onClick={(e) => { salvarAssinatura() }} >
                                            Salvar
                                        </Button>
                                    </ButtonGroup>

                                </Col>
                        </Row>
                    </Col>
                </Row>
            </DommusToggle>
        </div>
        </Container>
    )
}

